import { Company } from "../models/company.model";

export class AppStorage {
  static storedCompanyList: Company[] = [];
  static authState: "LOGGEDIN" | undefined = undefined;
  static selectedCompany: Company | undefined = undefined;

  static saveCompanyList = (companyList: Company[]): void => {
    this.storedCompanyList = companyList;
  };

  static getCompanyList = (): Company[] => {
    return this.storedCompanyList;
  };
}